import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface AccessSettingsIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const AccessSettingsIcon = ({ className, ...props }: AccessSettingsIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.421 11.5263H18.0631C18.3771 11.5263 18.6316 11.7808 18.6316 12.0947V13.4378M16.421 11.5263V7.73684C16.421 6.15789 15.5368 3 12 3C8.46315 3 7.57893 6.15789 7.57893 7.73684V11.5263M16.421 11.5263H7.57893M7.57893 11.5263H5.93683C5.6229 11.5263 5.36841 11.7808 5.36841 12.0947V20.4316C5.36841 20.7455 5.6229 21 5.93683 21H12.9701"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.42105"
    />
    <path
      d="M18 21C19.1046 21 20 20.1046 20 19C20 17.8954 19.1046 17 18 17C17.6357 17 17.2942 17.0974 17 17.2676C16.4022 17.6134 16 18.2597 16 19C16 19.7403 16.4022 20.3866 17 20.7324C17.2942 20.9026 17.6357 21 18 21Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z"
      stroke="currentColor"
      strokeDasharray="0.3 2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default AccessSettingsIcon;
